import Modal from '../../components/modal';

namespace('IO.Views.IccPolicies', function (exports) {
  'use strict';

  var ImpactedIccResourcesModal = Modal.extend({
    callbacks: [],

    template: 'icc_policies/impacted_icc_resources',

    dom: {
      OK_BUTTON: '#answer-ok',
    },

    open: function (data) {
      this.data = data;
      this._setupRender();
    },

    events: function () {
      var events = [];

      events['click ' + this.dom.OK_BUTTON] = 'close';

      return events;
    },

    _setupRender: function () {
      this.wait = false;
      this.setContent(
        this.renderTemplate(
          {
            data: this.data,
            width: 800,
            height: 500,
          },
          this.template,
        ),
      );

      this.show(
        {
          top: 100,
          left: ($(window).width() - 800) / 2,
        },
        {
          width: 800,
        },
      );
    },
  });

  exports.ImpactedIccResourcesModal = ImpactedIccResourcesModal;
});
